module.exports = __webpack_public_path__ + "img/avatar2.6c932065.png";